import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import Flex from "../../../../../../components/Flex";
import Text from "../../../../../../components/Text";
import AddIcon from "@mui/icons-material/Add";

interface SubmitFaxPopUpProps {
  onClick: (
    v:
      | "add_to_patient_chart"
      | "create_new_patient_profile"
      | "assign_to_patient"
  ) => void;
}

const SubmitFaxPopUp = ({ onClick }: SubmitFaxPopUpProps) => (
  <PopupState variant="popover" popupId="submit-fax-popup">
    {(menuList) => (
      <>
        <Box
          borderRadius={1}
          color={"white"}
          bgcolor={"primary.main"}
          px={1.2}
          {...bindTrigger(menuList)}
          sx={{ cursor: "pointer" }}
          width={"150px"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"center"}
            gap={0.8}
            height={"30px"}
          >
            <AddIcon />
            <Text variant="button" fontWeight={500}>
              Add On
            </Text>
            <Divider
              orientation="vertical"
              sx={{
                opacity: 0.5,
                border: "1px solid",
              }}
            />
            {bindMenu(menuList).open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Flex>
        </Box>
        <Menu {...bindMenu(menuList)}>
          <MenuItem
            onClick={() => {
              menuList.close();
              onClick("add_to_patient_chart");
            }}
          >
            <Flex gap={"10px"}>
              <Typography>Add to Patient Chart</Typography>
            </Flex>
          </MenuItem>
          {/* <MenuItem
            onClick={() => {
              menuList.close();
              onClick("create_new_patient_profile");
            }}
          >
            <Flex gap={"10px"}>
              <Typography>Create New Patient Profile</Typography>
            </Flex>
          </MenuItem> */}
          <MenuItem
            onClick={() => {
              menuList.close();
              onClick("assign_to_patient");
            }}
          >
            <Flex gap={"10px"}>
              <Typography>Assign & Create Task</Typography>
            </Flex>
          </MenuItem>
        </Menu>
      </>
    )}
  </PopupState>
);

export default SubmitFaxPopUp;
